var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDumbbell = function SvgDumbbell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.567 3.46-1.421 1.422a.684.684 0 0 0 .02.967l7.891 7.892a.684.684 0 0 0 .967.02l1.421-1.422a.684.684 0 0 0-.02-.967L12.535 3.48a.684.684 0 0 0-.967-.02ZM12.339 20.444l1.42-1.421a.684.684 0 0 0-.019-.967L5.85 10.164a.684.684 0 0 0-.967-.02L3.46 11.565a.684.684 0 0 0 .02.967l7.892 7.892a.684.684 0 0 0 .967.02ZM13.617 4.369l1.777-1.777a.93.93 0 0 1 .563-.274.645.645 0 0 1 .522.175l4.933 4.933c.13.13.193.318.175.522a.93.93 0 0 1-.274.563l-1.777 1.777M10.288 19.536l-1.776 1.776a.93.93 0 0 1-.563.274.645.645 0 0 1-.523-.175l-4.932-4.932a.644.644 0 0 1-.175-.523.93.93 0 0 1 .274-.563l1.776-1.776M10 14l4-4",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDumbbell;